module.exports = "/fast-coin/img/coin/anim/out_2/out_2_000.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/out_2/out_2_000.png
// module id = 2306
// module chunks = 5